import React from 'react'
import { styled } from "../../../stitches.config";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-up.svg?react'
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type SliderProps = {
    children: JSX.Element | JSX.Element[],
    className: string,
}

function NextArrow(props: any) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <ArrowRight />
        </div>
    );
}

function PrevArrow(props: any) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33594 16.4819L3.03299 18.179L11.9966 9.2154L20.9602 18.179L22.6573 16.4819L11.9966 5.82129L1.33594 16.4819ZM11.9964 8.79133L11.9962 8.79108L3.03275 17.7545L3.03299 17.7547L11.9964 8.79133ZM11.9964 6.24574L11.9966 6.24555L22.233 16.4819L20.9602 17.7547L20.96 17.7545L22.2326 16.4819L11.9964 6.24574Z" fill="#FFFFFF" />
            </svg>
        </div>
    );
}

const CustomSlider = ({ children, className, ...settings }: SliderProps) => {

    settings = {
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        ...settings,
    }

    return (
        <div className={className}>
            <Slider {...settings}>
                {children}
            </Slider>
        </div>
    )
}

export default CustomSlider;



